import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_remark",
  "use": "icon-control_remark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_remark\"><g transform=\"translate(2 2)\"><circle stroke=\"currentColor\" fill=\"transparent\" cx=\"6\" cy=\"6\" r=\"5.5\" /><g transform=\"translate(5.006 2.02)\"><circle stroke=\"#FFF\" stroke-width=\".5\" cx=\"1\" cy=\"1\" r=\"1\" /><path stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" d=\"M.994 2.981v4\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol